import React from "react";
import styles from "./VoucherTypeSelector.module.scss";
import FormikSearchSelector from 'gui/components/formikSearchSelector/FormikSearchSelector';
import {SelectOption} from 'react-select-material-ui';
import {voucherTypeToLabel} from "data/enums/products";

export interface ISelectorProps {
  label: string;
  voucherTypes: SelectOption[];
}


const VoucherTypeSelector = (props: ISelectorProps) => {
  return (
    <FormikSearchSelector
      className={styles.voucherTypeSelector}
      options={props.voucherTypes}
      {...props}
    />
  );
};


export const voucherTypes = voucherTypeToLabel
  Object.keys(voucherTypeToLabel)
    .map((voucherType, index) => ({label: `${voucherTypeToLabel[voucherType]}`, value: parseInt(voucherType, 10)}));


VoucherTypeSelector.defaultProps = {
  voucherTypes
};

export default React.memo(VoucherTypeSelector);
